import { IEmptyState } from 'app/interfaces/empty-state/empty-state.interface';
import { IInputModel, IOptions } from 'app/interfaces/input/input.interface';
import { ITextLabel } from 'app/interfaces/text-label/textLabel.interface';
import ImagePath from 'app/utilities/imagePath';

export const transactionTypes: IOptions[] = [
	{
		value: '1',
		label: 'Top Up',
	},
	{
		value: '2',
		label: 'Funding',
	},
	{
		value: '6',
		label: 'Withdraw',
	},
	{
		value: '5',
		label: 'Repayment',
	},
];

export const transactionStatus: IOptions[] = [
	{
		value: '1',
		label: 'Success',
	},
	{
		value: '2',
		label: 'In Progress',
	},
	{
		value: '3',
		label: 'Failed',
	},
];

export const transactionHistoryFilterForm: IInputModel[] = [
	{
		id: 'type',
		formType: 'select',
		placeholder: 'Jenis Transaksi',
		name: 'type',
		apiErrorMessage: '',
		options: transactionTypes,
		value: '',
	},
	{
		id: 'status',
		formType: 'select',
		placeholder: 'Status',
		name: 'status',
		apiErrorMessage: '',
		options: transactionStatus,
		value: '',
	},
	{
		id: 'datePickerStart',
		formType: 'datePicker',
		placeholder: 'Tanggal Transaksi',
		name: 'startDate',
		apiErrorMessage: '',
		options: [],
		value: '',
	},
];

export const transactionHistoryEmptyState: IEmptyState = {
	image: ImagePath.noData,
	placeholder: 'Oops, saat ini belum ada Transaction History yang tersedia',
	caption: 'Transaction History Anda akan terdaftar di sini',
};

export const transactionHistoryFilterEmptyState: IEmptyState = {
	image: ImagePath.noDataFilter,
	placeholder: 'Oops, belum ada transaksi yang sesuai filter',
	caption: 'Coba reset atau ubah filter kamu, ya',
};

export const historyLoadingTextLabelInit: ITextLabel[] = [
	{
		title: '',
		value: '',
		bg: false,
	},
	{
		title: '',
		value: '',
		bg: false,
	},
	{
		title: '',
		value: '',
		bg: false,
	},
	{
		title: '',
		value: '',
		bg: false,
	},
];

export const transactionHistoryAction = [
	{
		id: 1,
		label: 'Unduh CSV',
	},
];

export const TRANSACTION_HISTORY_ENUM = {
	downloadCsv: 1,
};
